import { Collection } from 'modules/core/lib/mobx-rest'

import DataImport from 'modules/payroll_bundle/store/models/DataImport'

export class DataImports extends Collection<DataImport> {
  model() {
    return DataImport
  }

  async importFile(file: File) {
    return this.rpc('import_file', { file })
  }
}
